(function () {
  "use strict";

  /* ─── Configuration ─────────────────────────────────────────────────── */
  var IFRAME_SRC = "https://dashsquare.ovlapps.com/customizein3d";
  var TRUSTED_ORIGINS = ["https://dashsquare.ovlapps.com", "https://dashsquare.com", "https://quickstart-5713ec2b.myshopify.com"];
  var WRAPPER_ID = "configuratorWrapper";
  var IFRAME_ID = "configuratorIframe";
  var LOADER_ID = "sv-loader";

  var _loadHandler = null;
  var _hideTimer = null;
  var LOADER_HIDE_DELAY = 2500;

  function _showLoader() {
    var loader = document.getElementById(LOADER_ID);
    if (loader) loader.classList.remove("sv-hidden");
  }

  function _hideLoader() {
    var loader = document.getElementById(LOADER_ID);
    if (loader) loader.classList.add("sv-hidden");
  }

  /* ─── Open configurator ─────────────────────────────────────────────── */
  function openConfigurator() {
    var wrapper = document.getElementById(WRAPPER_ID);
    var iframe = document.getElementById(IFRAME_ID);
    if (!wrapper || !iframe) return;
    if (iframe.src !== IFRAME_SRC) {
      _showLoader();
      iframe.src = IFRAME_SRC;
      _loadHandler = function () {
        _loadHandler = null;
        _hideTimer = setTimeout(function () { _hideLoader(); _hideTimer = null; }, LOADER_HIDE_DELAY);
      };
      iframe.addEventListener("load", _loadHandler, { once: true });
    }
    wrapper.classList.add("sv-open");
    document.body.style.overflow = "hidden";
  }

  /* ─── Close configurator ────────────────────────────────────────────── */
  function closeConfigurator() {
    var wrapper = document.getElementById(WRAPPER_ID);
    var iframe = document.getElementById(IFRAME_ID);
    if (!wrapper || !iframe) return;
    wrapper.classList.remove("sv-open");
    if (_loadHandler) {
      iframe.removeEventListener("load", _loadHandler);
      _loadHandler = null;
    }
    if (_hideTimer) {
      clearTimeout(_hideTimer);
      _hideTimer = null;
    }
    _showLoader();
    iframe.src = "";
    document.body.style.overflow = "";
  }

  /* ─── postMessage listener ──────────────────────────────────────────── */
  function onMessage(event) {
    if (TRUSTED_ORIGINS.indexOf(event.origin) === -1) {
      console.warn("[opus_shopify] Blocked message from untrusted origin:", event.origin, "| data:", event.data);
      return;
    }
    if (!event.data) return;

    if (event.data.type === "close-configurator" || event.data.type === "CLOSE_CONFIGURATOR") {
      closeConfigurator();
      return;
    }

    if (event.data.type === "change-iframe-url") {
      var newUrl = event.data.url;
      var iframe = document.getElementById(IFRAME_ID);
      if (!iframe) {
        console.error("[opus_shopify] iframe not found with id:", IFRAME_ID);
        return;
      }
      _showLoader();
      iframe.src = newUrl;
      _loadHandler = function () { _hideLoader(); _loadHandler = null; };
      iframe.addEventListener("load", _loadHandler, { once: true });
      return;
    }
  }

  /* ─── Bind launch button ────────────────────────────────────────────── */
  function bindLaunchButton() {
    var btn = document.getElementById("HeaderMenu-try-our-configurator");
    if (!btn || btn.dataset.svBound) return;
    btn.dataset.svBound = "1";
    btn.addEventListener("click", function (e) { e.preventDefault(); openConfigurator(); });
  }

  /* ─── Bind .is-configurator elements ───────────────────────────────── */
  function bindConfiguratorLinks() {
    var els = document.querySelectorAll(".is-configurator");
    els.forEach(function (el) {
      if (el.dataset.svBound) return;
      el.dataset.svBound = "1";
      el.addEventListener("click", function (e) { e.preventDefault(); openConfigurator(); });
    });
  }

  /* ─── Bind close button (inside wrapper) ───────────────────────────── */
  function bindCloseButton() {
    var closeBtn = document.getElementById("sv-close-btn");
    if (closeBtn) closeBtn.addEventListener("click", closeConfigurator);

    var wrapper = document.getElementById(WRAPPER_ID);
    if (wrapper) {
      wrapper.addEventListener("click", function (e) {
        if (e.target === wrapper) closeConfigurator();
      });
    }
  }

  /* ─── Initialise ────────────────────────────────────────────────────── */
  function init() {
    bindLaunchButton();
    bindConfiguratorLinks();
    bindCloseButton();
    window.addEventListener("message", onMessage);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
